module.exports = __webpack_public_path__ + "img/natureza.02528c88.png";